"use strict";

import * as THREE from "three";

const AlpineLilyStamen: ShootPreset = {
    id: "AlpineLilyStamen",
    shootCount: 6,

    maxWidth: .075,
    maxHeight: .075,

    lengthSegments: 6,
    widthSegments: 4,

    materialPreset: {
        uniforms: {
            shootTextureIndex: { value: 16 },
            shootTextureColorA: { value: new THREE.Color(0.79, 0.66, 0) },
            shootTextureColorB: { value: new THREE.Color(0.5, 0, 0.01) },
        },
    },

    pathFunction: () => {
        let points = [
            new THREE.Vector3(.1, .1, 0),
            new THREE.Vector3(.25, 1.25, 0),
            new THREE.Vector3(.45, 1.5, 0),
        ];

        let path = new THREE.CatmullRomCurve3(points);

        return path;
    },

    getTaper(position) {
        if (position < .75) {
            return .25;
        } else {
            return (Math.sin((position - .75) * 4 * Math.PI) + 1) / 2;
        }
    },

    getNormalOffset(lengthProgress, widthProgress) {
        let taper = this.getTaper(lengthProgress);
        return Math.sin(widthProgress * Math.PI) * taper;
    },

    getBinormalOffset(lengthProgress, widthProgress) {
        let taper = this.getTaper(lengthProgress);
        return Math.cos(widthProgress * Math.PI) * taper;
    },

    transformInstance(i) {
        let progress = (i / this.shootCount);

        const rotation = new THREE.Euler(0, 0, 0);
        const quaternion = new THREE.Quaternion();
        const matrix = new THREE.Matrix4();

        rotation.y = progress * 2 * Math.PI;

        quaternion.setFromEuler(rotation);

        matrix.compose(
            new THREE.Vector3(),
            quaternion,
            new THREE.Vector3(1, 1, 1));

        return matrix;
    },
}

const AlpineLilyPetal: ShootPreset =
{
    id: "AlpineLilyPetal",

    shootCount: 6,
    maxWidth: .45,

    lengthSegments: 10,
    widthSegments: 6,

    materialPreset: {
        uniforms: {
            shootTextureIndex: { value: 0 },
            shootTextureColorA: { value: new THREE.Color(0.87, 0.71, 0.01) },
            shootTextureColorB: { value: new THREE.Color(0.5, 0, 0.01) },
        },
    },

    pathFunction: () => {

        let width = 3 + Math.random() * 3;

        let points = [
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(1, 1.5, 0),
            new THREE.Vector3(2, .75, 0),
        ];

        let path = new THREE.CatmullRomCurve3(points);

        return path;
    },

    getNormalOffset: (lengthProgress, widthProgress) => {
        return Math.pow(Math.sin((1 - lengthProgress) * .9 * Math.PI) * widthProgress, 1.5);
    },
}

export const AlpineLily: BloomPreset = {
    bounds: 2,
    shootPresets: [AlpineLilyPetal, AlpineLilyStamen]
}
